
import { useEffect, useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import {
  useParams,
  useSearchParams,
} from 'react-router-dom';
import {
  getDetail,
  getGeneralProjectProposalInfo,
} from 'apis/midtermReviews.api';
import { Detail } from 'features/MidtermReview/components';
import Loading from 'components/Loading';
import { getAllVersions } from 'apis/projectProposals.api';
import DynamicMidtermForm from 'features/MidtermReview/components/DynamicMidtermForm';
import { is1593 } from 'utils/func';

export default function DetailM06() {
  const { projectProposalId } = useParams();
  const [searchParams] = useSearchParams();
  const councilId = searchParams.get('councilId');
  const councilMemberId = searchParams.get('councilMemberId');

  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);

  const {
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: {
      errors,
      // , isValid
    },
  } = useForm({
    mode: 'onChange',
    // resolver: yupResolver(updateMidtermReviewValidationSchema),
  });
  const { isDirty, dirtyFields } = useFormState({ control });

  const { data: allProjectProposalVersionsData, isLoading: isLoadingAllVersion } = useQuery(
    ['allProjectProposalVersions', projectProposalId],
    () => getAllVersions(projectProposalId)
  );

  // The projectProposal version ONLY used to get information of projectProposal (A. General)
  const prequalificationVersion = useMemo(() => {
    if (allProjectProposalVersionsData?.data?.length > 0) {
      return (
        (allProjectProposalVersionsData?.data?.find((item) => item?.version === 4) ||
          allProjectProposalVersionsData?.data?.find((item) => item?.version === 1)) ??
        null
      );
    }
    return null;
  }, [allProjectProposalVersionsData]);

  const { data: projectProposalData, isLoading: isProjectProposalLoading } = useQuery(
    ['specialize-review', 'project-proposal', councilId, prequalificationVersion?.id],
    ({ queryKey: [, , _councilId, _projectProposalId] }) =>
      getGeneralProjectProposalInfo(_councilId, _projectProposalId),
    { enabled: !!prequalificationVersion?.id }
  );
  const projectProposal = useMemo(() => projectProposalData?.data ?? {});

  const {
    // mutate: mutateUpdate,
    error: errorRes,
    isError: isErrorRes,
    isLoading: isLoadingCreate,
  } = useMutation(() => true);

  const {
    data: midtermReviewData,
    isLoading: isLoadingMidtermReview,
    // refetch: refetchMidtermReview,
  } = useQuery(['midterm-review'], () => getDetail(councilMemberId, councilId, projectProposalId));

  const midtermReviews = useMemo(() => midtermReviewData?.data?.midtermReview, [midtermReviewData]);

  useEffect(() => {
    setValue('reviewResearchPlan', midtermReviews?.reviewResearchPlan);
    setValue('reviewProduct', midtermReviews?.reviewProduct);
    setValue('reviewProgress', midtermReviews?.reviewProgress);
    setValue('reviewExpenditureUsed', midtermReviews?.reviewExpenditureUsed);
    setValue('reviewContinueAbility', midtermReviews?.reviewContinueAbility);
    setValue('otherReview', midtermReviews?.otherReview);
    setValue('requestStop', midtermReviews?.requestStop);
    setValue('requestStopReason', midtermReviews?.requestStopReason);
    setValue('requestContinue', midtermReviews?.requestContinue);
    setValue('requestContinueModify', midtermReviews?.requestContinueModify);
    setValue('evaluate.evaluateResearchPlan.isQualified', midtermReviews?.evaluateResearchPlan);
    setValue('evaluate.evaluateResearchResult.isQualified', midtermReviews?.evaluateResearchResult);
    setValue('evaluate.evaluateProgress.isQualified', midtermReviews?.evaluateProgress);
    setValue(
      'evaluate.evaluateExpenditureUsed.isQualified',
      midtermReviews?.evaluateExpenditureUsed
    );
    setValue('evaluate.evaluateGeneral.isQualified', midtermReviews?.evaluateGeneral);
    setValue('evaluate.evaluateResearchPlan.isNotQualified', !midtermReviews?.evaluateResearchPlan);
    setValue(
      'evaluate.evaluateResearchResult.isNotQualified',
      !midtermReviews?.evaluateResearchResult
    );
    setValue('evaluate.evaluateProgress.isNotQualified', !midtermReviews?.evaluateProgress);
    setValue(
      'evaluate.evaluateExpenditureUsed.isNotQualified',
      !midtermReviews?.evaluateExpenditureUsed
    );
    setValue('evaluate.evaluateGeneral.isNotQualified', !midtermReviews?.evaluateGeneral);
  }, [midtermReviews]);

  const template = useMemo(
    () => parseInt(projectProposal.template, 10) || null,
    [projectProposalData]
  );

  const renderForm = () => {
    if (is1593(template) || isProjectProposalLoading) {
      return (
        <DynamicMidtermForm
          projectProposalId={prequalificationVersion?.id}
          councilMemberId={councilMemberId}
          councilId={councilId}
          generalInfo={projectProposal}
          isLoading={isProjectProposalLoading || isLoadingAllVersion}
          readOnly
        />
      );
    }
    return (
      <Detail
        isLoadingCreate={isLoadingCreate || isProjectProposalLoading}
        isErrorRes={isErrorRes}
        errorRes={errorRes}
        control={control}
        watch={watch}
        setValue={setValue}
        getValues={getValues}
        isDirty={isDirty}
        dirtyFields={dirtyFields}
        errors={errors}
        reset={reset}
        isVisibleErrorDialog={isVisibleErrorDialog}
        setIsVisibleDialogError={setIsVisibleDialogError}
      />
    );
  };
  // #endregion

  return (
    <>
      {isLoadingCreate && isLoadingMidtermReview && <Loading />}
      {renderForm()}
    </>
  );
}
